import cloneDeep from 'lodash/cloneDeep'

import selectGraphType from './select-graph-type'

export default function (graphOptions) {
  const GraphType = selectGraphType(graphOptions.graphType)
  // Graph rendering modifies the object with which it is initialised
  // so unless we clone we won't be able to use it again for rendering.
  return new GraphType(cloneDeep(graphOptions))
}
